// extracted by mini-css-extract-plugin
export var downArrow = "_a1-0";
export var infoTooltipIcon = "_a1-3";
export var label = "_a1-1";
export var optionCard = "_a1-4";
export var upArrow = "_a1-2";